import React, {useState} from 'react';
import b_ from 'b_';

import './horizontal-selector.css';
import HelpBlock from '../help-block';

const b = b_.with('horizontal-selector');

interface Option<T> {
    value: T;
    content: string | React.ReactNode;
    disabled?: boolean;
    detailsPopup?: string | React.ReactNode;
}

interface Props<T extends string | number> {
    options: Option<T>[];
    onChange: (option: T) => void;
    initialSelected?: T;
    filter?: (option: T) => boolean;
    theme?: 'default' | 'light';
    disabled?: boolean;
}

export default function HorizontalSelector<T extends string | number>(props: Props<T>) {
    const {
        options,
        initialSelected,
        onChange,
        filter = () => true,
        theme = 'default',
        disabled
    } = props;

    const filteredOptions: Option<T>[] = [];

    options.forEach(option => {
        if (filter(option.value)) {
            filteredOptions.push(option);
        }
    });
    const [selected, setSelected] = useState(initialSelected || filteredOptions[0].value);

    const handleSelect = (option: Option<T>) => {
        if (option.disabled) return false;
        setSelected(option.value);
        onChange(option.value);
    };

    return (
        <div className={b({disabled})}>
            <div className={b('grid', {theme})}>
                {filteredOptions.map(option => (
                    <div
                        key={option.value}
                        className={b('option', {
                            isSelected: selected === option.value,
                            disabled: option.disabled
                        })}
                        onClick={() => handleSelect(option)}
                    >
                        {option.disabled ? (
                            <>
                                <div className={b('option-disabled-title')}>{option.content}</div>
                                <HelpBlock>{option.detailsPopup}</HelpBlock>
                            </>
                        ) : (
                            option.content
                        )}
                    </div>
                ))}
            </div>
            <div className={b('fill')} />
        </div>
    );
}
